/** Matches the Auth0 redirect callback route (`/callback`), with or without a trailing slash. */
const AUTH0_CALLBACK_PATHNAME_REGEX = /^\/callback\/?$/;

/**
 * Whether the given pathname is the Auth0 redirect callback route.
 *
 * The callback route exchanges the auth code and provisions the account before
 * a usable session (and access token) exists. Callers use this to avoid firing
 * authenticated queries while it runs, since those would transiently fail with
 * a missing-token or unauthorized error.
 *
 * @param pathname - A URL pathname (e.g. `window.location.pathname`).
 * @returns True when the pathname is the callback route.
 */
export function isAuth0CallbackPathname(pathname: string): boolean {
	return AUTH0_CALLBACK_PATHNAME_REGEX.test(pathname);
}
